import React from "react";
import { TRANSLATION_CONST } from "../_redux/_constants";
export const LanguageOptions = Object.values(TRANSLATION_CONST).map(
  ({ lan, name, symbol }) => ({
    value: lan,
    label: (
      <div
        className={
          lan === TRANSLATION_CONST.ENGLISH.lan
            ? "df-log df-lang-opt"
            : lan === TRANSLATION_CONST.SINHALA.lan
              ? "df-log df-lang-opt df-lang-f-s"
              : lan === TRANSLATION_CONST.TAMIL.lan
                ? "df-log df-lang-opt df-lang-f-t"
                : "df-lang-opt"
        }
      >
        <span
          className={
            lan === TRANSLATION_CONST.ENGLISH.lan
              ? "df-lang-thmb"
              : lan === TRANSLATION_CONST.SINHALA.lan
                ? "df-lang-thmb df-lo-s"
                : lan === TRANSLATION_CONST.TAMIL.lan
                  ? "df-lang-thmb df-lo-t"
                  : "df-lang-thmb"
          }
        >
          {symbol}{" "}
        </span>{" "}
        {name}
      </div>
    ),
  }),
);

export const DashboardLanguageOptions = [
  {
    value: "en",
    label: (
      <div className="df-lang-opt-nav">
        <span className="df-lang-thmb">A </span> <span>English</span>
      </div>
    ),
  },
  {
    value: "ta",
    label: (
      <div className="df-lang-opt-nav">
        <span className="df-lang-thmb df-lo-t">அ </span>
        <span className="df-lang-f-t"> தமிழ்</span>
      </div>
    ),
  },
  {
    value: "si",
    label: (
      <div className="df-lang-opt-nav">
        <span className="df-lang-thmb df-lo-s">අ </span>
        <span className="df-lang-f-s">සිංහල</span>
      </div>
    ),
  },
];
